import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import MainLayout from "../../components/layouts/MainLayout";
import { Buffer } from "buffer";

import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { Button, DatePicker, Form, Input, message, Modal, Select, Table, Tooltip } from "antd";
import { CloudSyncOutlined, CopyOutlined } from "@ant-design/icons";

import { ListLoanBpkbStates } from "./types/ListLoanBpkbTypes";
import { loanService } from "../../services/otodisApi/LoanService";

import ModalDetailLoan from "../../components/loan/ModalDetailLoan";
import SelectLeasing from "../../components/selects/SelectLeasing";

export interface HomeProps {}

class ListLoanBpkb extends Component<HomeProps & any, ListLoanBpkbStates> {
  private readonly initState!: ListLoanBpkbStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");
  private tableColumn: any = [
    {
      title: "Loan Code & No BPKB",
      dataIndex: "loan_code",
      width: 180,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>{" "}
            <Tooltip title="Click untuk copy" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>{" "}
            <br />
            <span className={`font-90`}>
              {row.bpkb_number}{" "}
              <Tooltip title="Click untuk copy" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(row.bpkb_number)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Offer Code",
      dataIndex: "additional_data",
      width: 180,
      render: (value: any) => {
        return (
          <React.Fragment>
            <span className={`font-90`}>
              {value.offer_code}
              <Tooltip title="Click untuk copy" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value.offer_code)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Buat",
      dataIndex: "created_date",
      width: 100,
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => {
        return new Date(a.created_date).getTime() - new Date(b.created_date).getTime();
      },
      sortDirections: ["descend", "ascend"], // Optional: to control sort direction
      render: (value: string, row: any) => {
        const date = moment(value).format("YYYY-MM-DD");
        return date;
      },
    },
    {
      title: "Tgl Expired",
      width: 100,
      dataIndex: "loan_expired_date",
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => {
        return new Date(a.created_date).getTime() - new Date(b.created_date).getTime();
      },
      sortDirections: ["descend", "ascend"], // Optional: to control sort direction
      render: (value: string, row: any) => {
        const date = value ? moment(value).format("YYYY-MM-DD") : "";
        return date;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Konsumen",
      dataIndex: "customer_name",
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span>{value}</span>
            <br />
            <span style={{ fontSize: "70%", fontStyle: "italic", fontWeight: "bold" }}>
              rek : {row.customer_bank_provider_short_name} {row.customer_bank_account_number}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Leasing",
      dataIndex: "leasing_code",
      width: 200,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span>
              {value} - {row.leasing_name}
            </span>
            <br />
            <span style={{ fontSize: "70%", fontStyle: "italic", fontWeight: "bold" }}>
              rek : {row.leasing_bank_provider_short_name} {row.leasing_bank_account_number}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Komisi Leasing",
      dataIndex: "leasing_incentive",
      render: (value: number) => {
        return value.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "Agen",
      dataIndex: "marketing_agen_name",
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span>{value}</span>
            <br />
            <span style={{ fontSize: "70%", fontStyle: "italic", fontWeight: "bold" }}>
              rek : {row.marketing_bank_provider_short_name} {row.marketing_bank_account_number}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Komisi Agen",
      dataIndex: "marketing_incentive",
      render: (value: number) => {
        return value.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "Tenor",
      dataIndex: "loan_tenor",
    },

    {
      title: "Total Pencairan",
      dataIndex: "loan_amount",
      render: (value: number) => {
        return value.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      title: "Kendaraan",
      dataIndex: "category",
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "90%" }}>
              {value} - {row.branch_name} - {row.model_name} - {row.manufacture_year}
            </span>
            <br />
            <span style={{ fontSize: "90%" }}>{row.variant_code}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "No kendaraan",
      dataIndex: "plate_number",
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span>
              {value}{" "}
              <Tooltip title="Click untuk copy">
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>{" "}
            </span>
            <br />
            <span style={{ fontSize: "70%" }}>
              {row.engine_number}{" "}
              <Tooltip title="Click untuk copy">
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(row.engine_number)} />
              </Tooltip>{" "}
            </span>
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      processingFetchTableData: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      pageSize: 100,

      filterBpkbNumber: "",
      filterLoanStatus: "ACTIVE",
      filterLoanLeasing: "ALL",
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),

      dataLoan: [],
      rowDetailLoan: [],

      showModalDetailLoan: false,
      showModalUpdateOwner: false,
      showModalImage: false,
      modalImageUrl: "",
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  closeModalDetailOrder = (data: any) => {
    this.setState({
      showModalDetailLoan: false,
    });
  };

  showDetail = async (data: any) => {
    await this.promisedSetState({
      rowDetailLoan: data,
      showModalDetailLoan: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });
  };

  fetchLoanData = async () => {
    await this.promisedSetState({
      dataLoan: [],
      processingFetchTableData: true,
    });

    let params: any = {
      branch_code: this.state.dealerCode,
      bpkb_number: this.state.filterBpkbNumber,
    };

    if (this.state.filterBpkbNumber === "") {
      params = {
        branch_code: this.state.dealerCode,
        status: this.state.filterLoanStatus,
        leasing_code: this.state.filterLoanLeasing === "ALL" ? null : this.state.filterLoanLeasing,
        date_type: "CreatedDate",
        date_start: moment(this.state.filterStartDate).startOf("month").format("YYYY-MM-DD"),
        date_end: moment(this.state.filterStartDate).endOf("month").format("YYYY-MM-DD"),
      };
    }

    loanService.setToken(this.token);
    loanService
      .getLoanBpkb(params)
      .then(async (value) => {
        await this.promisedSetState({
          dataLoan: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataLoan: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onChangeLeasing = (data: any) => {
    this.setState({
      filterLoanLeasing: data.value,
      //   supplierName: data.children,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "filterStartDate" | "filterEndDate" | "filterLoanStatus" | "filterBpkbNumber">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterStartDate":
        currentState.filterStartDate = value;
        break;
      case "filterEndDate":
        currentState.filterEndDate = value;
        break;
      case "filterLoanStatus":
        currentState.filterLoanStatus = value;
        break;
      case "filterBpkbNumber":
        currentState.filterBpkbNumber = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  configModalImage = async (showModal: boolean, imgUrl: string) => {
    await this.promisedSetState({
      showModalImage: showModal,
      modalImageUrl: imgUrl,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Loan`} breadcrumbMenu={`List Loan`} defaultSelectedKeys={["m-loan-bpkb"]} defaultOpenKeys={["sm-loan"]}>
          <div style={{ padding: 20 }}>
            <Form layout={`inline`}>
              <Form.Item className={"padTop-10"} label="">
                <i className={`small-text-grey`}>Tanggal Buat</i>
                <br />
                <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM")} onChange={(event) => this.onFieldChange("filterStartDate", event)} format={"YYYY-MM"} picker="month" />
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140 }}>
                <i className={`small-text-grey`}>Status</i>
                <Select showSearch placeholder="Status Loan" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterLoanStatus", value)} value={this.state.filterLoanStatus}>
                  <Select.Option key={`ACTIVE`} value={`ACTIVE`}>{`ACTIVE`}</Select.Option>
                  <Select.Option key={`CANCELED`} value={`CANCELED`}>{`CANCELED`}</Select.Option>
                  {/*<Select.Option key={`REJECTED`} value={`REJECTED`}>{`REJECTED`}</Select.Option>
                  <Select.Option key={`CANCELED`} value={`CANCELED`}>{`CANCELED`}</Select.Option> */}
                  {/*<Select.Option key={`DISBURSEMENT_PENDING`} value={`DISBURSEMENT_PENDING`}>{`DISBURSEMENT PENDING`}</Select.Option>*/}
                  {/*<Select.Option key={`DISBURSEMENT_SUCCESS`} value={`DISBURSEMENT_SUCCESS`}>{`DISBURSEMENT SUCCESS`}</Select.Option>*/}
                </Select>
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140 }}>
                <i className={`small-text-grey`}>Select Leasing</i>
                <SelectLeasing onSupplierChangeProps={this.onChangeLeasing} dealerCode={this.state.dealerCode} value={this.state.filterLoanLeasing} />
              </Form.Item>

              <Form.Item className={"padTop-10"} style={{ minWidth: 120 }}>
                <i className={`small-text-grey`}>No BPKB</i>
                <Input value={this.state.filterBpkbNumber} onChange={(event) => this.onFieldChange("filterBpkbNumber", event.target.value)} placeholder="No BPKB" />
              </Form.Item>

              <Form.Item className={"padTop-20"}>
                <Button onClick={this.fetchLoanData} type="primary" icon={<CloudSyncOutlined />}>
                  {" "}
                  Go{" "}
                </Button>
              </Form.Item>
            </Form>
          </div>
          <br />

          <Table
            rowKey={"loan_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataLoan}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal visible={this.state.showModalImage} footer={null} onCancel={() => this.configModalImage(false, "")}>
            <img src={this.state.modalImageUrl} alt="Zoom" style={{ width: "100%" }} />
          </Modal>
          <ModalDetailLoan kodeOrder={"aaaa"} dataLoan={this.state.rowDetailLoan} visible={this.state.showModalDetailLoan} onClose={this.closeModalDetailOrder} />
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(ListLoanBpkb), 65);
